module.exports = __webpack_public_path__ + "img/history.967e17e7.svg";